export interface File {
  downloadPath: string;
  fileName: string;
}

export const doDownLoadFile = function (file: File) {
  return new Promise<void>(async (resolve, reject) => {
    try {
      const dom = document.createElement('a');
      dom.href = file.downloadPath;
      dom.download = file.fileName;
      dom.style.display = 'none';
      document.body.appendChild(dom);
      dom.click();
      dom.parentNode.removeChild(dom);
      window.URL.revokeObjectURL(file.downloadPath);
      resolve();
    } catch (err) {
      reject(err);
    }
  });
};

export const downLoadFile = async (url: string) => {
  return window.fetch(url).then(async (res) => {
    const dispositionName: string = res.headers.get('Content-Disposition');
    const [, , fileName] = decodeURIComponent(dispositionName.match(/=(.*)$/)[1]).split("'");
    const a = await res.blob();
    const blob = new Blob([a], { type: `application/octet-stream` });
    const downloadPath = window.URL.createObjectURL(blob);
    return doDownLoadFile({ fileName, downloadPath });
  });
};

const splicingQueryParameters = (parameters: Record<string, any>) => {
  const str = Object.keys(parameters).reduce((pre, cur) => {
    return pre + cur + '=' + encodeURIComponent(parameters[cur]) + '&';
  }, '');

  return '?' + str.substring(0, str.length - 1);
};

export const wxEnvDownload = (query: Partial<File>) => {
  return new Promise((resolve, reject) => {
    wx.miniProgram.navigateTo({
      url: `/pages/downloadfile/index${splicingQueryParameters(query)}`,
      success: resolve,
      fail: reject,
    });
  });
};

export const isMiniprogram = () => {
  return new Promise<void>((resolve, reject) => {
    if (!/MicroMessenger/i.test(navigator.userAgent)) {
      reject();
      return;
    }
    let windows: any = window;
    windows = windows.wx ? windows : parent.window;
    if (!windows.wx) reject();
    windows.wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        resolve();
      } else {
        reject();
      }
    });
  });
};
